const PROXY_URL = 'https://pb.movemaestro.com/v3/mmapi/';
const TWS_LOGIN = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/TWSForgotLogin';
const TWS_REGISTER = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twsregister?client=civilian';
const QAS = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/QAS';
const AAD = 'movemaestro.com';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
}